'use strict';

const axios = require('axios');
const { validateElement } = require('../../../vue-form/vue-input/libs/validator');

module.exports = (paymentsDTO) => {
    return {
        namespaced: true,
        state: {
            paymentData: {
                adyenData: null,
                cardHolderName: null,
                brandCode: null,
                saveCreditCard: null,
                shopperInteraction: null
            },
            adyenData: {
                loaded: false,
                clientToken: null,
                paymentData: null
            },
            giftcardPaymentError: null,
            focusCreditCardBlock: false,
            paymentRequiredActionData: null, // used when adyen demands additional checks to accept payment
            ...paymentsDTO,
            showEditModeError: false,
            paymentMethodError: null,
            backupedPaymentMethod: null,
            setSecuredFieldsStyle: {
                error: {
                    color: '#d6122d'
                },
                placeholder: {
                    fontFamily: 'ScalaSansOT, Segoe UI, Roboto, Helvetica Neue, sans-serif',
                    fontSize: '16px',
                    color: '#aeaeae',
                    letterSpacing: '0.5px',
                    lineHeight: '24px'
                },
                base: {
                    fontFamily: 'ScalaSansOT, Segoe UI, Roboto, Helvetica Neue, sans-serif',
                    fontSize: '16px',
                    color: '#1A1919',
                    fontSmoothing: 'antialiased',
                    letterSpacing: '0.5px',
                    lineHeight: '24px'
                }
            },
            amazonButtonType: paymentsDTO.amazonButtonType,
            paymentDescriptor: ''
        },
        getters: {
            mbwayField: (state) => {
                return state.forms.mbway.formElements.find(element => element.id === 'mbway-phone-number');
            },
            blikField: (state) => {
                return state.forms.blik.formElements.find(element => element.id === 'blik-pincode');
            },
            bankOptionsField: (state) => (paymentType) => {
                const form = state.forms[paymentType];
                return form && form.formElements.find(element => element.id === 'bank-options-' + paymentType);
            },
            giftcardOptionsField(state) {
                return state.forms.giftcards.formElements.find(element => element.id === 'giftcard-options');
            },
            hasNoGiftCardOptions(state) {
                return state.forms.giftcards.formElements.find(element => element.id === 'giftcard-options').attributes.options.length == 1;
            },
            hasOneGiftCardOption(state) {
                return state.forms.giftcards.formElements.find(element => element.id === 'giftcard-options').attributes.options.length == 2;
            },
            hasMoreGiftCardOption(state) {
                return state.forms.giftcards.formElements.find(element => element.id === 'giftcard-options').attributes.options.length > 2;
            },
            getField: (state) => (formId, fieldId) => {
                const form = state.forms[formId];
                const formElements = form ? form.formElements : state.forms.formElements;
                return formElements.find(element => element.id === fieldId);
            },
            getFieldValue: (state) => (formId, fieldId) => {
                const form = state.forms[formId];
                const formElements = form ? form.formElements : state.forms.formElements;
                const formElement = formElements.find(element => element.id === fieldId);
                return formElement ? formElement.state.value : null;
            },
            isFormValid: (state) => (formId) => {
                const elements = state.forms[formId].formElements;
                return elements.reduce((result, element) => {
                    return result && !validateElement(element).length;
                }, true);
            }
        },
        actions: {
            setSelectedPaymentMethod({state, commit, dispatch}, args) {
                const paymentMethod = args.paymentMethod;
                const revertChanges = args.revertChanges;
                const data = {
                    paymentMethod: paymentMethod.type,
                    readMode: !!state.preselectedPaymentMethod,
                    paymentData: paymentMethod.paymentData,
                    revertChanges: revertChanges
                };
                if (paymentMethod.issuerId) {
                    data.issuerId = paymentMethod.issuerId;
                }
                return axios({
                    method: 'post',
                    url: paymentMethod.setPaymentMethodUrl,
                    data: data,
                    headers: { 'Content-Type': 'application/json' },
                })
                    .then((res) => {
                        if (!res || !res.data || res.data.error) {
                            return {error: true};
                        }
                        const newPaymentMethod = {...paymentMethod};
                        if (res.data.giftCardData) {
                            dispatch('setGiftCardData', res.data.giftCardData);
                        }
                        commit('updateSelectedPaymentMethod', newPaymentMethod);
                        commit('updatePropertyValue', {
                            propertyName: 'adyenData',
                            value: {
                                loaded: false,
                                clientToken: null,
                                paymentData: null,
                            }
                        });
                        return {error: false};
                    });
            },
            setGiftCardData({commit}, giftCardData) {
                commit('setAppliedGiftcards', giftCardData.appliedGiftcards);
                commit('orderSummary/updatePropertyValue', { propertyName: 'giftCardDeductionAmount', value: giftCardData.giftCardsTotalAmount }, { root: true });
                commit('orderSummary/updatePropertyValue', { propertyName: 'giftCardDeductionAmountValue', value: giftCardData.giftCardsTotalAmountValue }, { root: true });
                commit('orderSummary/updatePropertyValue', { propertyName: 'orderTotalsPrice', value: giftCardData.remainingAmount }, { root: true });
                commit('orderSummary/updatePropertyValue', { propertyName: 'orderTotalsPriceValue', value: giftCardData.remainingAmountValue }, { root: true });
                commit('orderSummary/updatePropertyValue', { propertyName: 'orderTotalsPriceForAdyen', value: giftCardData.remainingAmountForAdyen }, { root: true });
                commit('updatePropertyValue', { propertyName: 'payingFullAmountWithGiftcard', value: giftCardData.remainingAmountValue <= 0 });
            }
        },
        mutations: {
            setPaymentsData(state, paymentsData) {
                Object.assign(state, paymentsData);
            },
            updatePropertyValue(state, args) {
                const { propertyName, value } = args;
                state[propertyName] = value;
            },
            updateSelectedPaymentMethod(state, paymentMethod) {
                state.selectedPaymentMethod = paymentMethod;
            },
            updatePreselectedPaymentMethod(state, paymentMethod) {
                state.preselectedPaymentMethod = paymentMethod;
            },
            setReadMode(state, readMode) {
                state.readMode = readMode;
            },
            setAdyenPaymentData(state, adyenPaymentData) {
                state.paymentData.adyenData = adyenPaymentData;
            },
            setCardHolderName(state, cardHolderName) {
                state.paymentData.cardHolderName = cardHolderName;
            },
            setSaveCreditCard(state, saveCreditCard) {
                state.paymentData.saveCreditCard = saveCreditCard === 'on';
            },
            setBrandCode(state, brandCode) {
                state.paymentData.brandCode = brandCode;
            },
            setShopperInteraction(state, shopperInteraction) {
                state.paymentData.shopperInteraction = shopperInteraction;
            },
            setPaymentRequiredActionData(state, paymentRequiredActionData) {
                state.paymentRequiredActionData = paymentRequiredActionData;
            },
            setAppliedGiftcards(state, appliedGiftcards) {
                state.appliedGiftcards = appliedGiftcards;
            },
            setPaymentDescriptor(state, paymentDescriptor) {
                state.paymentDescriptor = paymentDescriptor;
            },
            backupSelectedPaymentMethod(state, giftcardType) {
                if (!giftcardType) {
                    state.selectedPaymentMethod = state.backupedPaymentMethod;
                    state.backupedPaymentMethod = state.defaultPaymentMethod;
                } else {
                    state.backupedPaymentMethod = state.selectedPaymentMethod;
                    state.selectedPaymentMethod = state.defaultPaymentMethod;
                }
            },
            updateFieldValue(state, args) {
                const { formId, fieldId, value } = args;
                const formElements = state.forms[formId] ? state.forms[formId].formElements : state.forms.formElements;
                const element = formElements.find(element => element.id === fieldId);
                if (!element) {
                    return;
                }
                element.state.value = typeof value === 'string' ? value.replace(/\s+/g, ' ').trim() : value;
                if (element.attributes.options && element.attributes.options.length) {
                    element.state.selectedOption = element.attributes.options.find(option => option.id === value);
                }
                element.state.__ob__.dep.notify(); // if the initial value === trimmed value the components won't be notified
                element.validationErrors = validateElement(element);
            },
            validateForm(state, formId) {
                const elements = state.forms[formId].formElements;
                elements.forEach(element => {
                    element.validationErrors = validateElement(element);
                });
            },
            clearForm(state, formId) {
                const form = state.forms[formId];
                if (!form) {
                    return;
                }

                form.formElements.forEach(element => {
                    if (typeof element.state.value === 'boolean') {
                        element.state.value = false;
                        return;
                    }
                    element.state.value = '';
                    element.state.htmlValue = '';
                    element.validationErrors = [];
                    if (element.attributes.options && element.attributes.options.length) {
                        element.state.selectedOption = element.attributes.options[0];
                    }
                });
            },
            setShowEditModeError(state, showEditModeError) {
                state.showEditModeError = showEditModeError;
            },
            focusCreditCardBlock(state, shouldFocus) {
                state.focusCreditCardBlock = shouldFocus;
            },
            setPaymentMethodError(state, paymentMethodError) {
                state.paymentMethodError = paymentMethodError;
            }
        }
    };
};
